import { Sparkles } from "lucide-react";

export default function BrandMark({ compact = false }) {
  return (
    <span className={`brand-mark ${compact ? "brand-mark-compact" : ""}`}>
      <span className="brand-mark-word">GLOW</span>
      <Sparkles aria-hidden="true" size={compact ? 12 : 15} strokeWidth={1.5} />
      <span className="brand-mark-sub">CLEANING CO.</span>
    </span>
  );
}
